import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeachHeroSectionComponent } from './components/teach-hero-section/teach-hero-section.component';
import { TeachFeaturesSectionComponent } from './components/teach-features-section/teach-features-section.component';
import { TeachHowItWorksSectionComponent } from './components/teach-how-it-works-section/teach-how-it-works-section.component';
import { TeachFaqSectionComponent } from './components/teach-faq-section/teach-faq-section.component';
import { TeachCtaSectionComponent } from './components/teach-cta-section/teach-cta-section.component';

@Component({
  selector: 'black-teach',
  templateUrl: './teach.component.html',
  styleUrls: ['./teach.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    TeachHeroSectionComponent,
    TeachFeaturesSectionComponent,
    TeachHowItWorksSectionComponent,
    TeachFaqSectionComponent,
    TeachCtaSectionComponent,
  ],
})
export class TeachComponent implements OnInit {
  ngOnInit(): void {}
}
